module.exports = __webpack_public_path__ + "img/Tessellate15.fe9865cc.jpg";